import React from "react";
import "./SisterConcern.css";

import greenland from "../../../assets/logo/greenland.jpg";
import soft from "../../../assets/logo/soft.jpg";
import tracker from "../../../assets/logo/Iconic-Trucker-logo-1.png";
import tours from "../../../assets/logo/travel.jpg";
import transport from "../../../assets/logo/transport.jpg";
import shikhon from "../../../assets/logo/shikhon.jpg";
import digital from "../../../assets/logo/digital.jpg";
import furniture from "../../../assets/logo/furniture.jpg";
import motors from "../../../assets/logo/motors.jpg";
import express from "../../../assets/logo/express.jpg";
import holiday from "../../../assets/logo/Iconic_holiday.png";
import bdiconic from "../../../assets/logo/BD_Iconic_preview.png";

const servicesData = [
  {
    id: 1,
    title: "Iconic Express",
    icon: express,
    url: "https://iconicexpressbd.com/",
  },
  {
    id: 2,
    title: "Iconic Greenland",
    icon: greenland,
    url: "https://iconicgreenland.com",
  },
  {
    id: 3,
    title: "Iconic Digital Solutions",
    icon: digital,
    url: "https://iconicdigitalsolution.com/",
  },
  {
    id: 4,
    title: "Iconic Soft Ltd.",
    icon: soft,
    url: "https://iconicsoftltd.com/",
  },
  {
    id: 5,
    title: "Iconic Furniture",
    icon: furniture,
    url: "https://iconicfurniturebd.com/",
  },
  {
    id: 6,
    title: "BD Iconic",
    icon: bdiconic,
    url: "https://bdiconicksa.com/",
  },

  {
    id: 7,
    title: "Iconic Global Travels LTD",
    icon: tours,
    url: "https://iconicglobaltravels.com/",
  },
  {
    id: 8,
    title: "Iconic Motors",
    icon: motors,
    url: "https://iconicmotorsltd.com",
  },
  {
    id: 9,
    title: "Iconic Holiday",
    icon: holiday,
    url: "https://iconicholidaysbd.com/",
  },
  {
    id: 10,
    title: "Iconic Shikhon",
    icon: shikhon,
    url: "https://iconicshikhon.com",
  },
  {
    id: 11,
    title: "Iconic Transport",
    icon: transport,
    url: "https://iconictransportbd.com/",
  },
  {
    id: 12,
    title: "Iconic Tracker",
    icon: tracker,
    url: "https://iconictracker.com/",
  },
];

const SisterConcern = () => {
  const handleVisit = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="services-section">
      <div className="services-container">
        <h2 className="services-title" style={{ color: "#bd06b3" }}>
          OUR SISTER <span style={{ color: "#00bfff" }}>CONCERN</span>
        </h2>

        <p className="services-subtitle">
          One platform, multiple professional services to meet your needs
        </p>

        <div className="services-grid">
          {servicesData.map((service) => (
            <div className="service-card" key={service.id}>
              <div className="service-icon">
                <img src={service.icon} alt={service.title} />
              </div>

              <h3 className="service-name">{service.title}</h3>

              <button
                className="service-btn"
                onClick={() => handleVisit(service.url)}
              >
                Visit
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SisterConcern;
